export class CookiesKey {
  static readonly token = '__TOKEN'
  static readonly user = '__USER';
  static readonly medicinesToCompare = '__MEDICINES_TO_COMPARE'
  static readonly users = '__USERS'
  static readonly location = '__LOCATION'
  static readonly reviews = '__REVIEWS'
  static readonly selectedBatch = '__SELECTED_BATCH'
  static readonly chats = '__CHATS'
  static readonly lastNotificationVisit = '__LAST_NOTIFICATION_VISIT'
  static readonly timeRange = '__TIME_RANGE'
  static readonly skillLevel = '__SKILL_LEVEL'
  static readonly eventDate = '__EVENT_DATE'
  static readonly commentMessage = '__COMMENT_MESSAGE'
}

export const useCookies = () => {

  const setCookie = (key: string, value: string | null, options: {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean
  } = {}) => {
    let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(value || '')}`;

    const expires =
      options.expires instanceof Date
        ? options.expires.toUTCString()
        : new Date(Date.now() + (options.expires ?? 730) * 1000 * 60 * 60).toUTCString();
    cookieString += `; expires=${expires}`;

    if (options.path) {
      cookieString += `; path=${options.path}`;
    }

    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }

    if (options.secure) {
      cookieString += '; secure';
    }

    document.cookie = cookieString;
  };

  const getCookie = (key: string): string | null => {
    const cookies = document.cookie
      .split('; ')
      .reduce((acc: Record<string, string>, cookie) => {
        const [k, v] = cookie.split('=');
        acc[decodeURIComponent(k)] = decodeURIComponent(v || '');
        return acc;
      }, {});

    return cookies[key] || null;
  };

  const deleteCookie = (key: string) => {
    setCookie(key, null, { expires: -1 });
  };

  return {setCookie, getCookie, deleteCookie};
};